var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuide2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1548_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FF2147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00023 10.8C8.67431 10.8 8.36103 10.6739 8.12602 10.448C7.89102 10.2222 7.75251 9.91418 7.73953 9.58852L7.57324 5.38945C7.56657 5.21972 7.59423 5.05039 7.65458 4.89161C7.71493 4.73283 7.80672 4.58787 7.92444 4.46542C8.04217 4.34296 8.1834 4.24554 8.33969 4.17899C8.49597 4.11244 8.66408 4.07814 8.83394 4.07812H9.16652C9.33638 4.07814 9.5045 4.11244 9.66078 4.17899C9.81706 4.24554 9.9583 4.34296 10.076 4.46542C10.1937 4.58787 10.2855 4.73283 10.3459 4.89161C10.4062 5.05039 10.4339 5.21972 10.4272 5.38945L10.2609 9.58852C10.2479 9.91418 10.1094 10.2222 9.87444 10.448C9.63944 10.6739 9.32616 10.8 9.00023 10.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2595 12.662C10.2595 11.9663 9.69557 11.4023 8.99988 11.4023C8.3042 11.4023 7.74023 11.9663 7.74023 12.662C7.74023 13.3577 8.3042 13.9216 8.99988 13.9216C9.69557 13.9216 10.2595 13.3577 10.2595 12.662Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1548_442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide2);
export default __webpack_public_path__ + "static/media/Guide2.c4d91fb13342a6423c6f7dc16d7ad127.svg";
export { ForwardRef as ReactComponent };